import React, { useState, useEffect } from 'react';
import { likesAPI } from '../services/api';
import { getProfilePicture, getFirstName } from '../utils/helpers';
import { Link } from 'react-router-dom';

const Likes = () => {
  const [likes, setLikes] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchLikes();
  }, []);

  const fetchLikes = async () => {
    try {
      const response = await likesAPI.getLikes();
      setLikes(response.data.likes || []);
    } catch (error) {
      console.error('Failed to fetch likes:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="wrapper">
        <div className="section">
          <div className="container text-center">
            <h3>Loading...</h3>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="matchus-likes min-h-screen bg-gray-50">
      <div className="max-w-6xl mx-auto px-4 py-6">
        {/* Header */}
        <div className="mb-8">
          <h1 className="text-3xl font-bold text-gray-900 mb-2">Profile Likes</h1>
          <p className="text-gray-600">People who liked your profile</p>
        </div>

        {/* Content */}
              {likes.length === 0 ? (
          <div className="text-center py-16">
            <div className="mb-6">
              <div className="text-6xl mb-4">💖</div>
              <h2 className="text-2xl font-semibold text-gray-900 mb-2">No likes yet</h2>
              <p className="text-gray-600 max-w-md mx-auto">
                Keep using the app and updating your profile to get more likes from other users!
              </p>
            </div>
            <div className="text-sm text-gray-500">
              💡 Tip: Add more photos and complete your profile to attract more attention
            </div>
          </div>
        ) : (
          <>
            {/* Stats */}
            <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-4 mb-6">
              <div className="flex items-center justify-center">
                <div className="text-center">
                  <div className="text-2xl font-bold text-pink-500 mb-1">{likes.length}</div>
                  <div className="text-sm text-gray-600">
                    {likes.length === 1 ? 'Person liked your profile' : 'People liked your profile'}
                  </div>
                </div>
              </div>
            </div>

            {/* Likes Grid */}
            <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-6 gap-4">
                  {likes.map((like) => (
                <Link
                  key={like.id}
                  to={`/user/${like.viewer_id}`}
                  className="bg-white rounded-lg shadow-sm border border-gray-200 hover:shadow-md hover:border-pink-200 transition-all duration-200 overflow-hidden group"
                >
                  <div className="aspect-square overflow-hidden">
                    <img
                      className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-200"
                      src={getProfilePicture(like.viewer)}
                      alt={like.viewer.full_name}
                    />
                          </div>
                  <div className="p-3">
                    <h3 className="font-semibold text-gray-900 text-sm mb-1 truncate">
                      {getFirstName(like.viewer.full_name)}
                    </h3>
                    <p className="text-xs text-gray-500 mb-1">{like.viewer.age} years old</p>
                    <p className="text-xs text-gray-400 truncate">
                      {like.viewer.city && `${like.viewer.city}`}
                      {like.viewer.city && like.viewer.country && ', '}
                      {like.viewer.country}
                          </p>
                        </div>
                </Link>
                  ))}
                </div>

            {/* Encouragement Message */}
            <div className="mt-8 bg-gradient-to-r from-pink-50 to-red-50 rounded-lg p-6 text-center">
              <div className="text-2xl mb-2">🎯</div>
              <h3 className="font-semibold text-gray-900 mb-2">Keep it up!</h3>
              <p className="text-gray-600 text-sm">
                The more active you are, the more likes you'll receive. Don't forget to like profiles back!
              </p>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default Likes;

